import { ActionType } from "../action-types";
import { Action } from "../actions";
import { OperatorDto } from "../../dto/postLogin";

export interface OperatorsState {
  items: OperatorDto[];
  isLoading: boolean;
}

export const operatorsInitialState: OperatorsState = {
  items: [],
  isLoading: false,
};

const operatorsReducer = (
  state: OperatorsState = operatorsInitialState,
  action: Action
): OperatorsState => {
  switch (action.type) {
    case ActionType.SET_OPERATORS_LOADING: {
      return {
        ...state,
        isLoading: action.payload as boolean,
      };
    }

    case ActionType.SET_OPERATORS: {
      return {
        ...state,
        items: action.payload as OperatorDto[],
      };
    }

    case ActionType.RESET_OPERATORS: {
      return {
        ...operatorsInitialState,
      };
    }

    default:
      return state;
  }
};

export default operatorsReducer;
